"use client";

import { QuestionForm } from "./form";
import Image from "next/image";

export function AddQuestion() {
  return (
    <div
      className="relative flex flex-col w-full lg:flex-row items-center justify-center gap-6 p-2"
    >
      <div className="relative w-full lg:w-1/2 z-10">
        <div
          className="
            rounded-2xl shadow-md
            bg-[#c7d7fe]
            backdrop-blur-lg
            p-4
          "
        >
          <QuestionForm />
        </div>
      </div>

      <div className="relative w-full lg:w-1/2 flex flex-col items-center text-center md:text-right justify-center p-4 sm:p-6 z-10">
        <p className="text-gray-800 text-base sm:text-lg md:text-xl font-semibold mb-4 sm:mb-6 leading-relaxed">
          درهر مرحله از مسير موفقيت شما، ما آماده پاسخگویى به سوالات و نیازهای شما هستیم. با ما در تماس باشيد.
        </p>
        <div className="relative w-full max-w-60 sm:max-w-80 md:max-w-100 lg:max-w-120 aspect-square mx-auto">
          <Image
            src="/assets/contact-us.png"
            alt="contact us"
            fill
            sizes="(max-width: 640px) 240px, (max-width: 768px) 320px, (max-width: 1024px) 400px, 480px"
            className="object-cover"
          />
        </div>
      </div>
    </div>
  );
}
